import { initializeApp, FirebaseApp } from 'firebase/app';
import { getFirestore, collection, Firestore, CollectionReference, DocumentData } from 'firebase/firestore';
import { getStorage, FirebaseStorage } from 'firebase/storage';
import { getAuth, Auth } from 'firebase/auth';
import { getAnalytics, Analytics } from 'firebase/analytics';
import { getFunctions, httpsCallable, Functions, HttpsCallable } from 'firebase/functions';
import { FIREBASE_CONFIG, FIREBASE_COLLECTIONS } from '@/lib/constants';

// Initialize Firebase app
const app: FirebaseApp = initializeApp(FIREBASE_CONFIG);

// Initialize Firebase services
export const db: Firestore = getFirestore(app);
export const auth: Auth = getAuth(app);
export const storage: FirebaseStorage = getStorage(app);
export const analytics: Analytics = getAnalytics(app);
export const functions: Functions = getFunctions(app);

import { QwikUCard } from '@/types';

// Initialize commonly used collections
export const contactDocument: CollectionReference<QwikUCard> = collection(db, FIREBASE_COLLECTIONS.SMART_CARDS) as CollectionReference<QwikUCard>;

// Initialize Cloud Functions
export const sendNotification: HttpsCallable = httpsCallable(functions, 'sendNotification');

// Export the app instance as default
export default app;

